export const formSmallContainer = {
  display: 'flex',
  gap: '16px'
};

export const halfWidth = {
  width: '50%'
};

export const submitButton = {
  width: '45%',
  padding: '18px 0'
};

export const fullFieldWidth = {
  width: '100%'
};

export const arrayFieldWrapper = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 3
};

export const arrayFieldFormWrapper = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%'
};

export const arrayFieldFormContainer = {
  display: 'flex',
  alignItems: 'top',
  width: '100%'
};

export const labelSx = {
  fontSize: '0.75rem',
  transform: 'translate(12px, 12px) scale(1)',
  transition: 'transform 200ms ease-in-out',
  '&.Mui-focused': {
    transform: 'translate(12px, -6px) scale(0.75)'
  },
  '&.MuiInputLabel-shrink': {
    fontSize: '12px',
    transform: 'translate(14px, -6px) scale(0.75)'
  }
};

export const SIDEBAR_EXPANDED_WIDTH = '290px';
export const SIDEBAR_CLOSED_WIDTH = '120px';

export const loadingContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
};

export const actionButtonsContainerStyle = {
  display: 'flex',
  gap: '4px'
};

export const dotSeparatorStyle = {
  width: '0.1875rem',
  height: '0.1875rem',
  borderRadius: '50%',
  backgroundColor: '#e5e7eb'
};

export const approversTextStyle = {
  color: '#6b7280',
  fontSize: '0.75rem'
};

export const actionButtonBaseStyle = {
  fontSize: '0.625rem',
  padding: '0.125rem 0.5rem',
  minWidth: 'unset',
  textTransform: 'none',
  lineHeight: 1.75
} as const;

export const chipBaseStyle = {
  fontSize: '0.625rem',
  fontWeight: 600,
  height: '1.125rem',
  borderRadius: '0.1875rem'
} as const;

// Base reusable styles
export const baseHeader = {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#374151'
} as const;

export const baseCard = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5rem'
} as const;

export const baseSection = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '1rem',
  borderRadius: '0.5rem'
} as const;

export const baseInputRoot = {
  borderRadius: '8px'
} as const;

export const baseButton = {
  fontSize: '0.75rem',
  padding: '0.3125rem 0.625rem'
} as const;

export const baseName = {
  fontSize: '0.75rem',
  fontWeight: 600
} as const;
